import React, {useEffect, useState} from 'react';
import {useZooPassAppContext} from "../../Context/ZooPassAppContext";
export interface PassSelectCardBenefitProps {
    fetchKey: string;
    imgAlt: string;
    value1: number | boolean;
}

export const PassSelectCardBenefit: React.FC<PassSelectCardBenefitProps> = ({fetchKey, imgAlt, value1}) => {
    let {
        summaryTranslations,
        loading
    } = useZooPassAppContext();
    
    
    const [src, setImageSrc] = useState<string>("/favicon.ico");
    const [txt, setTxt] = useState<string | TrustedHTML>("");
    
    useEffect(() => {
        if(loading || summaryTranslations == null){
            setImageSrc("/favicon.ico");
            setTxt("");
            return;
        }
        const summaryItem = summaryTranslations.get(fetchKey);
        if(!summaryItem){
            setImageSrc("/favicon.ico");
            setTxt("");
            return;
        }
        setImageSrc(summaryItem.iconUrl || "/favicon.ico");
        let finalText = "";
        if(value1 == 0 || value1 === false){
            finalText = summaryItem.text0 || "";
        }
        if(value1 === 1){
            finalText = summaryItem.text1 || ""
        }
        if(typeof value1 === "number" && value1 > 1){
            const foundText = summaryItem.textM || "";
            finalText = foundText.replace("{0}", value1.toString());
        }
        if(value1 === true){
             const foundText = summaryItem.textM || "";
            finalText = foundText.replace("{0}", "");
        }
        setTxt(finalText);
    }, [loading, summaryTranslations, fetchKey, value1]);
    
    return (
        <>
            <img className="benefit-icon" width="28" height="28" src={src} alt={imgAlt} role="presentation"/>
            <span className="benefit-text" dangerouslySetInnerHTML={{__html : txt}}></span>
        </>
    );
}